export default "__VITE_ASSET__02df2009__"